<f-chart
  [view]="view"
  [xScale]="xScale"
  [yScale]="yScale"
  [yLineScale]="lineYScale"
  [animation]="animation"
  [integerYAxis]="integerYAxis"
  [fitContainer]="fitContainer"
  [lineAxisLabelText]="lineAxisLabelText"
  [lineAxisTickFormatting]="lineAxisTickFormatting"
  [showLineAxisGridlines]="showDashedSeriesGridlines"
  [truncateXAxisTicks]="truncateXAxisTicks"
  [truncateYAxisTicks]="truncateYAxisTicks"
  [rotateXAxisTicks]="rotateXAxisTicks"
  [maxXAxisTickLength]="maxXAxisTickLength"
  [maxYAxisTickLength]="maxYAxisTickLength"
  [maxYAxisTicksCount]="maxTicksCount"
  [xAxisTickFormatting]="xAxisTickFormatting"
  [yAxisTickFormatting]="effectiveYAxisTickFormatting"
  [showXAxisGridlines]="false"
  [showYAxisGridlines]="showYAxisGridlines"
  [showXAxisTicksLabels]="showXAxisTicksLabels"
  [showYAxisTicksLabels]="showYAxisTicksLabels"
  [showLineAxisTicksLabels]="showLineAxisTicksLabels"
  [xAxisTickLabelClasses]="xAxisTickLabelClasses"
  [xAxisTickLabelOffset]="xAxisTickLabelOffset"
  [showXAxisDomain]="showXAxisDomain"
  [showYAxisDomain]="showYAxisDomain"
  [popoverTemplate]="popoverTemplate"
  [popoverPlacement]="popoverPlacement"
  [legendOptions]="chartLegendOptions || legendOptions"
  [showLegend]="showLegend"
  [leftAxisLabelText]="leftAxisLabelText"
  [labelsOffset]="labelsOffset"
  [showLabels]="showLabels"
  [showBorders]="showBorders"
  [condensedOnDesktop]="condensedOnDesktop"
  [condensedAxisOnMobile]="condensedAxisOnMobile"
  [chartPatternsTemplate]="chartPatternsTemplate"
  (dimensionsChanged)="onDimensionsChanged($event)"
>
  @if (dimensions) {
  <!-- Render the line series with optional pointer-line support. -->
  <svg:g
    f-line-series
    [data]="lineSeriesData"
    [xScale]="xScale"
    [yScale]="yScale"
    [lineYScale]="lineYScale"
    [solidSeriesCount]="solidSeriesCount"
    [curved]="lineCurved"
    [lineWidth]="lineWidth"
    [lineClasses]="lineClasses"
    [legendOptions]="chartLegendOptions || legendOptions"
    [circleRadius]="circleRadius"
    [showPointerLine]="showPointerLine"
    [activeDataPointId]="activeDataPointId"
    [nearestXPointer]="pointerXCoordinate"
    [popoverTemplate]="popoverTemplate"
    [popoverPlacement]="popoverPlacement"
    [popoverOpenDelay]="popoverOpenDelay"
    [animationDuration]="animationDuration"
    [animationDelay]="animationDelay"
    [animation]="animation"
  />
  @if (interactions?.hover) {
  <!-- Transparent overlay captures pointer movement for hover feedback. -->
  <svg:rect
    class="f-line-chart-pointer-layer"
    [attr.width]="dimensions.width"
    [attr.height]="dimensions.height"
    [attr.data-automation-id]="'line-hover-area-' + (activeDataPointId > -1 ? activeDataPointId : 0)"
    fill="transparent"
    (mousemove)="onPointerMove($event)"
    (click)="onPointerClick($event)"
    (mouseleave)="onMouseLeave()"
  ></svg:rect>
  } }
</f-chart>
